export const SUPPORT_ICONS = [
  {
    name: '3M',
    img: '/p/landing/company-logos/3mv1.svg',
  },
  {
    name: 'Airbus',
    img: '/p/landing/company-logos/airbusv1.svg',
  },
  {
    name: 'Amazon',
    img: '/p/landing/company-logos/amazonv1.svg',
  },
  {
    name: 'AON',
    img: '/p/landing/company-logos/aonv1.svg',
  },
  {
    name: 'AT&T',
    img: '/p/landing/company-logos/at-tv1.svg',
  },
  {
    name: 'Dupont',
    img: '/p/landing/company-logos/dupontv1.svg',
  },
  {
    name: 'Ecovadis',
    img: '/p/landing/company-logos/ecovadisv1.svg',
  },
  {
    name: 'Honeywell',
    img: '/p/landing/company-logos/honeywellv1.svg',
  },
  {
    name: 'Merck',
    img: '/p/landing/company-logos/merckv1.svg',
  },
  {
    name: 'S&P Global',
    img: '/p/landing/company-logos/s-p-globalv1.svg',
  },
  {
    name: 'Shell',
    img: '/p/landing/company-logos/shellv1.svg',
  },
  {
    name: 'Siemens',
    img: '/p/landing/company-logos/siemens.svg',
  },
];

export const PLAN_DETAILS = {
  free: [
    {
      id: 'free-company-coverage',
      label: '3 Company Verification',
      tooltip: "Access to company's certificates",
    },
    {
      id: 'free-certificate-coverage',
      label: '3 Certificate Verification',
      tooltip: "Access to a company's profile",
    },
  ],
  basic: [
    {
      id: 'basic-company-coverage',
      label: '150 Companies',
      tooltip: 'Verify and track all certificates all year',
    },
    {
      id: 'basic-searches',
      label: 'Unlimited searches',
      tooltip: 'Free to search, pay to verify',
    },
    {
      id: 'basic-bulk-matching',
      label: 'Bulk Matching',
      tooltip: 'With file upload',
    },
    {
      id: 'basic-watchlist',
      label: 'Watchlist',
      tooltip: 'Monitor selected certificates',
    },
    {
      id: 'basic-realtime-alerts',
      label: 'Real-time Alerts',
      tooltip: 'Notified instantly on status changes',
    },
  ],
  standard: [
    {
      id: 'standard-company-coverage',
      label: '350 Companies',
      tooltip: 'Verify and track all certificates all year',
    },
    {
      id: 'standard-searches',
      label: 'Unlimited searches',
      tooltip: 'Free to search, pay to verify',
    },
    {
      id: 'standard-bulk-matching',
      label: 'Bulk Matching',
      tooltip: 'Upload and matches at scale (10,000+ companies)',
    },
    {
      id: 'standard-watchlist',
      label: 'Watchlist',
      tooltip: 'Monitor selected certificates',
    },
    {
      id: 'standard-realtime-alerts',
      label: 'Real-time Alerts',
      tooltip: 'Notified instantly on status changes',
    },
  ],
  enterprise: [
    {
      id: 'enterprise-scale',
      label: 'Enterprise Scale',
      tooltip: '1000+ companies, customizable to your needs',
    },
    {
      id: 'enterprise-api-access',
      label: 'API Access',
      tooltip:
        'Export certification data seamless integration with your systems',
    },
    {
      id: 'enterprise-searches',
      label: 'Unlimited searches',
      tooltip: 'Pay only for matched results',
    },
    {
      id: 'enterprise-bulk-matching',
      label: 'Bulk Matching',
      tooltip: 'via file upload or API (unlimited companies)',
    },
    {
      id: 'enterprise-watchlist',
      label: 'Watchlist',
      tooltip: 'Monitor selected certificates',
    },
    {
      id: 'enterprise-realtime-alerts',
      label: 'Real-time Alerts',
      tooltip: 'Notified instantly on status changes',
    },
    {
      id: 'enterprise-unlimited-users',
      label: 'Unlimited Users Access',
      tooltip: 'Built for global corporations',
    },
  ],
};
